import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import useGetAiUsage from '../../api/useGetAiUsage';

type Props = {
  spaceId: string;
};

const MAX_PERCENT = 100;

const currencyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'USD' });

function formatUsd(value: number): string {
  return currencyFormatter.format(value);
}

export function getUsagePercent(costUsd: number, limitUsd: number): number {
  if (limitUsd <= 0) {
    return MAX_PERCENT;
  }
  return Math.min(Math.round((costUsd / limitUsd) * MAX_PERCENT), MAX_PERCENT);
}

export function useAiUsageCard(props: Props) {
  const { data, isLoading, error } = useGetAiUsage(props.spaceId);

  const costUsd = data?.costUsd ?? 0;
  const limitUsd = data?.limitUsd ?? 0;
  const percent = getUsagePercent(costUsd, limitUsd);

  return {
    isLoading,
    hasError: Boolean(error),
    monthLabel: format(new Date(), 'MMMM yyyy', { locale: fr }),
    calls: data?.calls ?? 0,
    costLabel: formatUsd(costUsd),
    limitLabel: formatUsd(limitUsd),
    percent,
    isLimitReached: data ? costUsd >= limitUsd : false,
  };
}
